import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Maintenance from "@/components/Maintenance";
import BeforeAfter from "@/components/BeforeAfter";
import Testimonials from "@/components/Testimonials";
import About from "@/components/About";
import Areas from "@/components/Areas";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function HomePage() {
  const location = useLocation();
  return (
    <>
      <SEO
        title="EcoJard | Jardinagem e Manutenção de Espaços Verdes | Arruda dos Vinhos, Alenquer, Vila Franca de Xira, Loures"
        description="Jardinagem, manutenção de jardins e condomínios, corte de relva e sebes e limpeza de terrenos em Arruda dos Vinhos, Alenquer, Vila Franca de Xira, Loures e Lisboa. Peça orçamento gratuito."
        path="/"
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Maintenance />
        <BeforeAfter />
        <Testimonials />
        <About />
        <Areas />
        <QuoteForm preselect={location.state?.service} />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
